module.exports = "<div class=\"bh-ename-container\" *ngFor=\"let ename of this.environment_name\">\n    <div>{{ename.Environment_Name}}</div>\n</div>"